module.exports = __webpack_public_path__ + "img/vip-know.faa9fe2c.png";